import { FunctionComponent, useState } from "react";

import { faPen } from "@fortawesome/pro-solid-svg-icons";

import { SecurityGroupRoleAssignmentsReadModel, StringReferenceReadModel } from "../../../../../../@api";

import { translationKeys } from "../../../../../models/app-translation-keys";
import { ColumnActionIcon } from "../../../../Shared/ColumnActionIcon/ColumnActionIcon";
import { ManageSecurityGroupDialog } from "../ManageSecurityGroupDialog/ManageSecurityGroupDialog";

export interface IAddSecurityGroupButtonProps {
  onAddedSecurityGroup(): void;
  roles?: StringReferenceReadModel[];
  data?: SecurityGroupRoleAssignmentsReadModel;
  hide?: boolean;
}

const EditSecurityGroupButton: FunctionComponent<IAddSecurityGroupButtonProps> = (
  props: IAddSecurityGroupButtonProps,
) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const handleCloseAddSecurityGroupDialog = (updatedRoleAssignment?: SecurityGroupRoleAssignmentsReadModel) => {
    setIsPopupVisible(false);

    if (updatedRoleAssignment?.securityGroup) {
      props.onAddedSecurityGroup();
    }
  };

  return (
    <div>
      {isPopupVisible && (
        <ManageSecurityGroupDialog
          isVisible={isPopupVisible}
          onHide={handleCloseAddSecurityGroupDialog}
          data={props.data}
          roles={props.roles}
        />
      )}

      {!props.hide && (
        <ColumnActionIcon
          rowData={props.data}
          icon={faPen}
          executeAction={rowData => setIsPopupVisible(true)}
          tooltipTranslationKey={translationKeys.adminArea.appRoles.actions.editAssignedRoles}
        />
      )}
    </div>
  );
};

export default EditSecurityGroupButton;
